

import { RegistereRibbonButton, useAppInfo, useModelDrivenApp, useModelDrivenViewContext, useRibbon, useSelectionContext } from "@eavfw/apps";
import { useEAVForm } from "@eavfw/forms";
import { useClientContext, useJsonFetcher } from "@eavfw/manifest";
import { runWorkflow } from "@eavfw/utils";
import {
    Button,
    Dialog, DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    Field,
    Input,
    Textarea
} from "@fluentui/react-components";
import { Spinner } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

RegistereRibbonButton("CUSTOM_RIBBON_SEND_TO_CAPTAIN", ({ key, ...props }) => {
    const { registerButton, events } = useRibbon();
    const { currentEntityName, currentRecordId } = useAppInfo();
    const { baseUrl } = useClientContext();
    const router = useRouter();
    const app = useModelDrivenApp();
    const [_baseUrl, fetcher] = useJsonFetcher();
    const { selection, selectionDetails } = useSelectionContext();
    const { mutate } = useModelDrivenViewContext();
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [isLoading, { toggle: toggleLoading }] = useBoolean(true);
    let [status] = typeof currentRecordId !== "undefined" ? useEAVForm(x => x.formValues.status) : [selection?.getSelection()[0]?.status];
    let [messageid, setMessageId] = useState<string>();
    let [message, setMessage] = useState<string>();
    let [subject, setSubject] = useState<string>();
    let [to, setTo] = useState<string>();
    let [cc, setcc] = useState<string>();
    console.log("CUSTOM_RIBBON_SEND_TO_CAPTAIN: ", [selectionDetails, message]);

    useEffect(() => {
        if (messageid && !message) {

            var timer = setInterval(async () => {
                var message = await fetcher(`${baseUrl}/entities/messages/records/${messageid}`, {});
                if (message.value.content)
                    setMessage(message.value.content);
                var vars = JSON.parse(message.value.variables);
                setSubject(vars.subject);
                setcc(vars.cc);
                setTo(vars.recipient.contactinfo);
                setSubject(vars.subject);
                //{\r\n  \"recipient\": {\r\n    \"name\": \"Poul Captain 2\",\r\n    \"id\": \"2d248e24-3064-4fac-3067-08dc182697dc\",\r\n    \"contactinfo\": \"pks@delegate.dk\"\r\n  },\r\n  \"loirequest\": {\r\n    \"id\": \"ce578110-c8f8-4e29-6c02-08dc80615712\",\r\n    \"title\": \"LOI for internal transfer\",\r\n    \"vesselName\": \"BW WREN 6\",\r\n    \"voyageName\": \"VOY 036 \",\r\n    \"chartererName\": \"BP \",\r\n    \"cpName\": \"CP 31.05.2024\"\r\n  },\r\n  \"cc\": \"pks@delegate.dk,pks@delegate.dk,e3cc2a42.delegate.dk@emea.teams.ms\",\r\n  \"from\": \"e3cc2a42.delegate.dk@emea.teams.ms\",\r\n  \"subject\": \"BW WREN 6 / VOY 036  / BP  / CP 31.05.2024 / LOI Completed - 'LOI for internal transfer'\"\r\n}


            }, 1000);

            return () => { clearInterval(timer); }
        }

    }, [messageid, message])

    registerButton({
        key: key,
        showOnCard: true,
        text: props.text,
        iconProps: props.iconProps ?? { iconName: 'Send' },
        title: props.title ?? props.text,
        disabled: status !== 50 || (selection?.getSelectedCount() ?? 2) > 1,
        onClick: () => {
            toggleHideDialog();
            setTimeout(async () => {
                let { result, rsp } = await runWorkflow("SendToCaptainWorkflow", "Manual", { recordId: selection?.getSelection()[0].id, send: false });
                setMessageId(result.body.messageid);
                toggleLoading();

            });
        }
    }, [status, selectionDetails]);


    return <>
        <Dialog open={!hideDialog}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Sending the message to the captain.</DialogTitle>
                    <DialogContent>
                        {isLoading ? "Please wait..." : messageid ? "Message has been generated" : "The message has been sent to the captain."}

                        <Field label="Subject">
                            <Input disabled={true} value={subject ?? ''} />
                        </Field>
                        <Field label="To">
                            <Input disabled={true} value={to ?? ''} />
                        </Field>
                        <Field label="CC">
                            <Input   disabled={true} value={cc ?? ''} />
                        </Field>
                        <Field label="Message">
                            <Textarea rows={10} disabled={isLoading} value={message ?? ''} onChange={(e, data) => setMessage(data.value)} />
                        </Field>

                    </DialogContent>
                    <DialogActions fluid>
                        <Button
                            appearance="primary"
                            disabled={isLoading}
                            onClick={async () => {

                                toggleLoading();
                                
                                let { result, rsp } = await runWorkflow("SendToCaptainWorkflow", "Manual", {
                                    recordId: selection?.getSelection()[0].id,
                                    send: true,
                                    content: message
                                });


                                mutate();
                                toggleHideDialog();
                                router.reload();
                            }}>
                            {isLoading ? <Spinner /> : 'Send'}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    </>

});